<!--
  Author: Gary Hammock
  Version: 0.1.0
  Description: A page/view to enumerate credentials.

  Requires: CredentialRenderer
-->

<template>
  <article class="credentials">
    <h1 class="border-bottom">
      Education
    </h1>
    <credential-renderer
      img-src="/assets/img/third-party-logos/MTSU_Wordmark.png"
      provider-name="Middle Tennessee State University"
      credential-name="Master of Science - Computer Science"
      credential-url="https://mtsu.edu/programs/computer-science/"
      class="my-2"
    />
    <credential-renderer
      img-src="/assets/img/third-party-logos/UTSI_Wordmark.png"
      provider-name="University of Tennessee"
      credential-name="Master of Science - Mechanical Engineering"
      credential-url="https://www.utsi.edu/mechanical-aerospace-biomedical-engineering/"
      class="my-2"
    />
    <credential-renderer
      img-src="/assets/img/third-party-logos/TTU_Wordmark.png"
      provider-name="Tennessee Technological University"
      credential-name="Bachelor of Science - Mechanical Engineering"
      credential-url="https://www.tntech.edu/engineering/programs/me/index.php"
      class="my-2"
    />
    <h1 class="border-bottom">
      Credentials
    </h1>
    <credential-renderer
      v-for="(credential, index) in credentials"
      :key="index"
      :img-src="credential.imgSrc"
      :provider-name="credential.providerName"
      :credential-name="credential.credentialName"
      :credential-id="credential.credentialId"
      :credential-url="credential.credentialUrl"
      :verification-url="credential.verificationUrl"
      class="my-2"
    />
  </article>
</template>

<script>
// The credentials source information.
import credentials from './credentials.json'

// First-party imports.
import CredentialRenderer from '@/components/CredentialRenderer'

export default {
  name: 'PageCredentials',

  components: {
    CredentialRenderer
  },

  data () {
    return {
      credentials: credentials
    }
  }
}
</script>
